import React from 'react';

function Facilities() {
  const facilities = [
    { icon: 'fa-building', title: 'Auditorium', desc: 'The spacious auditorium is the heart and pressure point of the School and its activities.', details: 'A multi-purpose wonder, it is used daily for Assembly, as indoor badminton courts and also when the occasion demands as an impressive Auditorium with a seating capacity of 450 - a place where formal functions can be conducted with ease and efficiency.', img: '/images/facilities/auditorium.jpg' },
    { icon: 'fa-chalkboard', title: 'Smart Classrooms', desc: 'Modern, well-ventilated classrooms equipped with digital boards and interactive learning tools in association with Vistas Learning.', details: 'Our spacious classrooms feature ergonomic furniture, proper lighting, and audio-visual equipment. Each room is designed to accommodate 30-35 students comfortably, with smart boards for interactive lessons and air circulation systems for a comfortable learning environment year-round.', img: '/images/facilities/smart-classroom.jpg' },
    { icon: 'fa-book', title: 'Library', desc: 'Extensive collection of books, magazines, and digital resources to foster reading habits and research skills.', details: 'Our library houses over 5,000 books across various genres including fiction, non-fiction, reference materials, and periodicals. Students have access to digital catalogs, e-books, and a quiet reading area. Regular book fairs and reading programs encourage lifelong learning habits.', img: '/images/facilities/library.jpg' },
    { icon: 'fa-laptop', title: 'Computer Lab', desc: 'State-of-the-art computer lab with high-speed internet and latest software for digital literacy.', details: 'Featuring 40+ modern computers with high-speed internet connectivity, our computer lab introduces students to programming, digital design, and essential software skills. Regular updates ensure students learn on current technology, preparing them for the digital future.', img: '/images/facilities/computer-lab.jpg' },
    { icon: 'fa-futbol', title: 'Sports Ground', desc: 'Spacious playground for cricket, football, athletics, and other outdoor activities promoting physical fitness.', details: 'Our expansive sports ground includes facilities for cricket, football, volleyball, and athletics. With dedicated areas for different sports and proper equipment, students develop teamwork, discipline, and physical fitness. Regular sports events and inter-school competitions foster competitive spirit.', img: '/images/facilities/sports-ground.jpg' },
    { icon: 'fa-palette', title: 'Art & Craft Room', desc: 'Creative space for painting, drawing, and craft activities to nurture artistic talents and creativity.', details: 'A vibrant space filled with art supplies, easels, and creative materials where students explore various art forms. From painting and sketching to clay modeling and origami, our art room encourages self-expression and develops fine motor skills and aesthetic appreciation.', img: '/images/facilities/art-room.jpg' },
    { icon: 'fa-music', title: 'Music Room', desc: 'Dedicated space with musical instruments for vocal and instrumental training in various art forms.', details: 'Acoustically designed music room equipped with keyboards, tabla, guitar, and other instruments. Students receive training in both vocal and instrumental music, participate in choir activities, and perform in school events, building confidence and cultural appreciation.', img: '/images/facilities/music-room.jpg' }
  ];

  const amenities = [
    { icon: 'fa-wifi', title: 'High-Speed WiFi', desc: 'Campus-wide internet connectivity' },
    { icon: 'fa-video', title: 'CCTV Surveillance', desc: '24/7 security monitoring' },
    { icon: 'fa-laptop', title: 'Computer Lab', desc: 'Modern systems with internet' },
    { icon: 'fa-water', title: 'Purified Water', desc: 'RO water purifiers installed' }
  ];

  return (
    <section style={{background: 'linear-gradient(135deg, #fef3e2 0%, #fde8c7 100%)', minHeight: '100vh', padding: '20px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#7c2d12', fontWeight: 900, marginBottom: '20px'}}>Our Facilities</h2>
          <p style={{fontSize: '1.4rem', color: '#92400e', maxWidth: '800px', margin: '0 auto'}}>World-class infrastructure designed for holistic development</p>
        </div>

        <div style={{display: 'flex', flexDirection: 'column', gap: '30px', marginBottom: '80px'}}>
          {facilities.map((facility, i) => (
            <div
              key={i}
              style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                display: 'grid',
                gridTemplateColumns: i % 2 === 0 ? '550px 1fr' : '1fr 550px',
                border: '3px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(245, 158, 11, 0.3)';
                e.currentTarget.style.borderColor = '#f59e0b';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <div style={{position: 'relative', overflow: 'hidden', order: i % 2 === 0 ? 0 : 1}}>
                <img
                  src={facility.img}
                  alt={facility.title}
                  style={{width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s'}}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
              <div style={{padding: '40px', display: 'flex', flexDirection: 'column', justifyContent: 'center', order: i % 2 === 0 ? 1 : 0}}>
                <div style={{
                  background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                  width: '70px',
                  height: '70px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <i className={`fas ${facility.icon}`} style={{fontSize: '2rem', color: 'white'}}></i>
                </div>
                <h3 style={{fontSize: '1.8rem', color: '#92400e', marginBottom: '15px', fontWeight: 700}}>{facility.title}</h3>
                <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '15px'}}>{facility.desc}</p>
                <p style={{color: '#78350f', fontSize: '1rem', lineHeight: 1.6, fontStyle: 'italic'}}>{facility.details}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{background: 'white', padding: '60px', borderRadius: '20px', marginBottom: '60px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)'}}>
          <h3 style={{fontSize: '2.5rem', color: '#92400e', textAlign: 'center', marginBottom: '50px', fontWeight: 800}}>Additional Amenities</h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px'}}>
            {amenities.map((amenity, i) => (
              <div
                key={i}
                style={{
                  textAlign: 'center',
                  padding: '30px',
                  background: '#fef3c7',
                  borderRadius: '15px',
                  transition: 'all 0.3s ease',
                  border: '2px solid transparent'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.borderColor = '#92400e';
                  e.currentTarget.querySelectorAll('*').forEach(el => el.style.color = 'white');
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#fef3c7';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.querySelector('i').style.color = '#f59e0b';
                  e.currentTarget.querySelector('h4').style.color = '#92400e';
                  e.currentTarget.querySelector('p').style.color = '#64748b';
                }}
              >
                <i className={`fas ${amenity.icon}`} style={{fontSize: '3rem', color: '#f59e0b', marginBottom: '15px', display: 'block', transition: 'color 0.3s'}}></i>
                <h4 style={{fontSize: '1.2rem', color: '#92400e', marginBottom: '8px', fontWeight: 700, transition: 'color 0.3s'}}>{amenity.title}</h4>
                <p style={{color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s'}}>{amenity.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{background: 'linear-gradient(135deg, #fecaca 0%, #fca5a5 100%)', padding: '50px', borderRadius: '20px', textAlign: 'center', color: '#991b1b', boxShadow: '0 10px 30px rgba(220, 38, 38, 0.15)'}}>
          <i className="fas fa-shield-alt" style={{fontSize: '3rem', color: '#dc2626', marginBottom: '20px'}}></i>
          <h3 style={{fontSize: '2rem', color: '#991b1b', marginBottom: '15px', fontWeight: 800}}>Safety & Security</h3>
          <p style={{fontSize: '1.2rem', color: '#7f1d1d', lineHeight: 1.8, maxWidth: '900px', margin: '0 auto'}}>
            Student safety is our top priority. Our campus is equipped with CCTV cameras, trained security personnel, fire safety equipment, and regular safety drills to ensure a secure learning environment.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Facilities;
